module.exports = __webpack_public_path__ + "static/img/projectName.8270c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/projectName.png
// module id = nH/d
// module chunks = 1